// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".step-header[data-v-e2db6e5e] {\n  min-height: 150px;\n}", ""]);
// Exports
module.exports = exports;
